import React, { Component } from 'react'
import logo from '../logo_standalone_plus.svg';

class Header extends Component {
    static nameToLink(name) {
        return '#' + name.toLowerCase()
            .replace('ä', 'ae')
            .replace('ü', 'ue')
            .replace('ö', 'oe')
            .replace('ß', 'ss')
            .replace(' ', '_');
    }

    render() {
        let sectionChildren = [];
        for (let i = 0; i < this.props.sections.length; i++) {
            let aChild = React.createElement('a',
                {
                    className: this.props.highlightedSection !== undefined ? (this.props.highlightedSection === i ? 'highlight' : '') : '',
                    href: Header.nameToLink(this.props.sections[i]),
                }, this.props.sections[i]);
            sectionChildren.push(React.createElement('li', { key: i }, aChild));
        }

        let gridTemplateColumns = '';
        for (let i = 0; i < this.props.sections.length; i++) {
            gridTemplateColumns += '1fr ';
        }

        gridTemplateColumns = gridTemplateColumns.trim();

        return (
            <header className={"App-header underline"}>
                <div className="App-header-box">
                    <div className="App-header-content">
                        <div className={(this.props.shrink ? "shrink" : "unshrink")}>
                            <a href="/#top"><img src={logo} fill="#F00" className="App-logo" alt="logo" /></a>
                            <ul style={{ gridTemplateColumns: gridTemplateColumns }}>
                                {sectionChildren}
                            </ul>
                        </div>
                    </div>
                </div>
            </header>
        );
    }
}

export default Header;


// WEBPACK FOOTER //
// ./src/header/header.js